import isObject from 'lodash/isObject'

export default {
	namespaced : true,
	state      : {
		plugins : [],
	},
	getters : {
		byId : state => (id) => {
			return state.plugins.find(p => p.id === id)
		},
	},
	mutations : {
		setPlugins (state, payload) {
			this._vm.$set(state, 'plugins', payload)
		},
	},
	actions : {
		fetch ({ commit }) {
			return new Promise((resolve, reject) => {
				commit('loading', 'plugins', { root: true })

				return this._vm.$api
					.get({ wpEndpoint: 'omapp/v1/plugins/' })
					.then(({ body }) => {
						commit('doneLoading', 'plugins', { root: true })
						commit('setPlugins', body)
						resolve()
					})
					.catch(error => {
						commit('setError', error, { root: true })
						commit('doneLoading', 'plugins', { root: true })
						reject(error)
						console.error({ error })
					})
			})
		},
		action ({ commit, dispatch, getters }, plugin) {
			return new Promise((resolve, reject) => {
				plugin = plugin && isObject(plugin)
					? plugin
					: getters.byId(plugin)

				if (!plugin) {
					return reject(new Error('No plugin id provided.'))
				}

				if (plugin.installed && plugin.active) {
					return resolve()
				}

				const payload = {
					id            : plugin.id,
					url           : plugin.url,
					nonce         : !plugin.installed ? plugin.install_nonce : plugin.activate_nonce,
					installAction : !plugin.installed ? 'install' : 'activate',
				}

				const handleError = (error) => {
					this._vm.$bus.$emit('pluginActionFailed', payload)
					commit('closeAlerts', null, { root: true })

					error.explanation = '<strong>Something went wrong</strong>'
					error.payload = payload
					commit('setError', error, { root: true })
					reject(error)

					console.error(`Could not ${payload.installAction} ${plugin.name}`, { error })
				}

				return this._vm.$api
					.post({ wpEndpoint: 'omapp/v1/plugins/' })
					.send(payload)
					.then(() => resolve())
					.catch(handleError)
			})
		},

	},
}
